import { useSelector, useDispatch } from "react-redux";
import "./Player.scss";
import React, { useEffect } from "react";

import { useParams, useNavigate } from "react-router-dom";
import { getPlayerInWeb } from "../../../store/reducers/reducerWeb";
import { checkClassTwo } from "../../tools/checkClass2";

import gamemaster from "../../../assets/imgs/gamemaster.png";
import OnlineIcon from "../../../assets/imgs/online.gif";
import OfflineIcon from "../../../assets/imgs/offline.gif";
import { classUser } from "../../tools/userClass";
import { checkGuildType } from "../../tools/checkGuildType";
import { CheckVip } from "../../tools/checkVip";
import Scrollto from "../../tools/scrollTo";

const Player = () => {
  const PlayerInfo = useSelector((state) => state.reducerWeb.PlayerInfo);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!params.id) return;
    dispatch(
      getPlayerInWeb({
        playername: params.id,
      })
    );
  }, [params.id, dispatch]);

  if (PlayerInfo.data === "err") {
    return <div className="PlayerInfoNotFound">No Player Found</div>;
  }

  return (
    <div>
      {PlayerInfo?.data?.map((user) => {
        if (!user.Name)
          return (
            <div key={user.Name} className="PlayerInfoNotFound">
              No Player Found
            </div>
          );
        return (
          <div key={user.Name} className="ContainerPlayerInfo">
            <Scrollto position={90} />

            <div className="PlayerInfoName">{user.Name}</div>

            <div className="SubContainerPlayerInfo">
              <div className="ContainerPlayerInfoImg">
                <img
                  className="PlayerInfoClassImg"
                  src={checkClassTwo(user.Class)}
                  alt=""
                />
              </div>

              <div className="ContainerPlayerInfoDetails">
                <div>Nick: {user.Name}</div>
                <div>
                  {user.CtlCode == 32 ? (
                    <div>
                      Type:
                      <span className="PlayerInfoGameMaster">
                        &nbsp;Game Master
                        <img src={gamemaster} alt="" />
                      </span>
                    </div>
                  ) : (
                    "Profile: Player"
                  )}{" "}
                </div>

                <div>Class: {classUser(user.Class)}</div>

                {/* Line Page */}
                <div
                  style={{
                    width: "100%",
                    borderBottom: "1px solid white",
                    margin: "10px  0px",
                  }}
                ></div>
                {/* End Line Page */}

                <div>
                  {user.CtlCode == 1 ? (
                    <div>
                      <div>
                        Player Ban:
                        <span className="PlayerInfoYesBan">&nbsp;Yes</span>
                      </div>
                      <div>
                        Ban By:
                        <span className="PlayerInfoYesBan">
                          &nbsp;{user.BanBy}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <span>
                        Player Ban: <span className="PlayerInfoNoBan">N/A</span>
                      </span>
                      <div>
                        Ban By:
                        <span>
                          &nbsp;
                          {!user.BanBy ? (
                            <span>N/A</span>
                          ) : (
                            <span className="PlayerInfoYesBan">
                              {user.BanBy}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Line Page */}
                <div
                  style={{
                    width: "100%",
                    borderBottom: "1px solid white",
                    margin: "10px  0px",
                  }}
                ></div>
                {/* End Line Page */}

                <div>
                  Status : &nbsp;
                  {user.ConnectStat == 1 ? (
                    <span>
                      <span style={{ color: "green" }}>ONLINE &nbsp;</span>
                      <img src={OnlineIcon} />
                    </span>
                  ) : (
                    <span>
                      <span style={{ color: "red" }}>OFFLINE &nbsp;</span>
                      <img src={OfflineIcon} />
                    </span>
                  )}
                </div>
                <div>Server : {user.ServerName}</div>

                <div>Level: {user.cLevel}</div>
                <div>Reset : {user.Reset}</div>
                <div>BCoin: {Number(user.BCoin) || 0}</div>
                <div>Credits: {Number(user.Credits) || 0}</div>
                <div>VIP: {CheckVip(user.vip, user.VIP_FULLDATE)}</div>
                <div>
                  {user.Wedding == 0 ? (
                    " Marry: N/A"
                  ) : (
                    <div>Marry to: {user.weddingname}</div>
                  )}
                </div>

                {/* Line Page */}
                <div
                  style={{
                    width: "100%",
                    borderBottom: "1px solid white",
                    margin: "10px  0px",
                  }}
                ></div>
                {/* End Line Page */}

                <div>
                  Guild:
                  <span className="PlayerInfoGuildName">
                    {!user.G_Name ? (
                      <span>&nbsp;N/A</span>
                    ) : (
                      <span
                        className="newCursor"
                        onClick={() => navigate(`/guild/${user.G_Name}`)}
                      >
                        &nbsp;{user.G_Name}
                      </span>
                    )}
                  </span>
                </div>

                <div className="containerPlayerInfoAlliance">
                  Alliance:
                  {!user.Alliance || user.Alliance.length == 0 ? (
                    <span className="PlayerInfoGuildName">&nbsp;N/A</span>
                  ) : (
                    user.Alliance.map((guild) => (
                      <span
                        className="newCursor PlayerInfoGuildName"
                        onClick={() => navigate(`/guild/${guild.G_Name}`)}
                      >
                        &nbsp;{guild.G_Name},&nbsp;
                      </span>
                    ))
                  )}
                </div>

                <div className="playerInfoJobGuild">
                  {checkGuildType(user.G_Status)}
                </div>

                {/* Line Page */}
                <div
                  style={{
                    width: "100%",
                    borderBottom: "1px solid white",
                    margin: "10px  0px",
                  }}
                ></div>
                {/* End Line Page */}

                <div>Strength: {user.Strength}</div>
                <div>Dexterity: {user.Dexterity}</div>
                <div>Vitality: {user.Vitality}</div>
                <div>Energy: {user.Energy}</div>
                {user.Class == 64 || user.Class == 66 ? (
                  <div>Command: {user.Leadership}</div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Player;
